import { Alert, Button, Modal, Spin } from "antd";
import React, { useState, useEffect } from "react";
import { StyleSheet, Text, View, Image, Dimensions } from "react-native";
import Settings from "../../shared/config/Settings";
import getUserId from "../../shared/core/GetToken";


import { useDispatch, useSelector } from "react-redux";
import { appServices } from "../../shared/redux/actions/appServices";
import getUserInfo from "../../shared/core/GetTokenized";
const AppointmentHandler = (props) => {
  const { Profile, isFetching } = useSelector((state)=> state.PatientProfile)
  // const [AppointmentDate, setAppointmentDate] = useState();
  const [dateLoading, setDateLoading] = useState(false);

  const dispatch=useDispatch()
  const {AvailableDateForAppointmentData , isAvailableDateForAppointmentData}=useSelector((state)=> state.AvailableDateForAppointment)
 
  // Array for month names
 


  


 


  // useEffect(() => {
  //   if(AvailableDateForAppointmentData){
  //     let list = [];
  //     let listMonths = [];
  //     if (AvailableDateForAppointmentData[0].entry) {
  //       AvailableDateForAppointmentData[0]?.entry.map((entry) => {
  //         list.push({
  //           ScheduleDate: entry?.resource?.extension[8]?.valueDateTime,
  //           SessionTitle: entry?.resource?.extension[10]?.valueString,
  //           LeaveCategory: entry?.resource?.extension[12]?.valueString,
  //         });
  //         if (
  //           !listMonths.includes(
  //             entry?.resource?.extension[11]?.valueString
  //           )
  //         ) {
  //           listMonths.push(entry?.resource?.extension[11]?.valueString);
  //         }
  //       });

  //       setAvailableMonths(listMonths)
  //       setappointmentDates(list);
  //       setRescheduleModal(true);
  //     } else {
  //       setNoDatemodal(true);
  //     }
  //   }
  // }, [AvailableDateForAppointmentData])
  
  
  
  // const dateForAppointment = (
  //   providersechduleID,
  //   AppointmentID,
  //   startDate,
  //   endDate
  // ) => {
  //   getUserId().then((userInfo) => {
  //     const item = JSON.parse(userInfo);
  //     var myHeaders = new Headers();
  //     setDateLoading(true);
  //     myHeaders.append("Token", item.token);

  //     var requestOptions = {
  //       method: "GET",
  //       headers: myHeaders,
  //       redirect: "follow",
  //     };
  //     const queryString = `?Token=${item.token}&PatientID=${item.userid}&ProviderScheduleID=${providersechduleID}&StartDate=${startDate}&EndDate=${endDate}&AppointmentID=${AppointmentID}`;
  //     fetch(
  //       Settings.apiUrl + "Patient/AvailableDateForAppointment" + queryString,
  //       requestOptions
  //     )
  //       .then((data) => data.json())
  //       .then((json) => {
  //         setDateLoading(false);
  //         let list = [];
  //         let listMonths = [];
  //         if (json[0].entry) {
  //           json[0]?.entry.map((entry) => {
  //             list.push({
  //               ScheduleDate: entry?.resource?.extension[8]?.valueDateTime,
  //               SessionTitle: entry?.resource?.extension[10]?.valueString,
  //               LeaveCategory: entry?.resource?.extension[12]?.valueString,
  //             });
  //             if (
  //               !listMonths.includes(
  //                 entry?.resource?.extension[11]?.valueString
  //               )
  //             ) {
  //               listMonths.push(entry?.resource?.extension[11]?.valueString);
  //             }
  //           });

  //           setAvailableMonths(listMonths)
  //           setappointmentDates(list);
  //           setRescheduleModal(true);
  //         } else {
  //           setNoDatemodal(true);
  //         }
  //       })
  //       .catch((err) => {
  //         setDateLoading(false);
  //       });
  //   });
  // };

  // const disableConsecutiveSlots=(slots, targetDuration= props.Duration)=> {
  //   let totalDuration = 0; // To track total duration of consecutive available slots
  //   let updatedSlots = [...slots]; // Copy the original slots array to update

  //   for (let i = 0; i < updatedSlots.length; i++) {
  //       // If the current slot is unavailable, continue to the next slot
  //       if (!updatedSlots[i].IsAvailable) {
  //           totalDuration = 0; // Reset total duration when slot is unavailable
  //           continue;
  //       }

  //       // Calculate the duration of the current slot based on its interval
  //       let interval = parseInt(updatedSlots[i].Interval) || 30; // Default to 30 minutes if interval is not specified
  //       totalDuration += interval;

  //       // If the total accumulated duration reaches or exceeds the target duration (60 minutes)
  //       if (totalDuration >= targetDuration) {
  //           // Mark all consecutive slots with IsAvailable true as disabled
  //           let j = i;
  //           let remainingDuration = totalDuration;

  //           // Disable the previous slots contributing to the total duration
  //           while (remainingDuration >= targetDuration && j >= 0 && updatedSlots[j].IsAvailable) {
  //               updatedSlots[j].Disabled = true; // Disable the current slot
  //               remainingDuration -= parseInt(updatedSlots[j].Interval);
  //               j--; // Move backwards to the previous slot
  //           }

  //           // After marking the slots, break the loop and move to the next available group
  //           break;
  //       }
  //   }
  
  //   setAppointmentSlots (updatedSlots);
  // }
  
  // const changediabledslot = (slots) => {
  //   if (parseInt(props.Duration) <= parseInt(slots[0].Interval)) {
  //     setAppointmentSlots(slots);
  //     setSlotLoading(false);
  //   } else {
  //     let remainingDuration = props.Duration;
  //     let currentSlot = slots[0];
  //     remainingDuration -= parseInt(currentSlot.Interval); // Reduce duration by current slot interval
  //     let i = 1; // Start from the next slot
  
  //     while (remainingDuration > 0 && i < slots.length) {
  //       const nextSlot = slots[i];
  //       // Exit the loop if the appointment limit is reached or the slot is not available
  //       if (nextSlot.AppointmentCount === nextSlot.SlotMaxBookingLimit || !nextSlot.IsAvailable) {
  //         setAppointmentSlots(slots);
  //         setSlotLoading(false);
  //         break; // Exit the loop
  //       }
  
  //       // If the start time of the next slot is after the end time of the current slot, modify it
  //       if (new Date(nextSlot.StartTime) > new Date(currentSlot.EndTime)) {
  //         // Add the new field Disabled: true to the next slot
  //         nextSlot.Disabled = true;
  
  //         // Update the remaining duration by subtracting the interval of the next slot
  //         remainingDuration -= parseInt(nextSlot.Interval);
  //       }
  
  //       // Move to the next slot
  //       currentSlot = nextSlot;
  //       i++;
  //     }
  
  //     // Check if we managed to cover the full duration
  //     if (remainingDuration <= 0) {
  //       setSlotLoading(false);
  //       setAppointmentSlots(slots); // Successfully covered the duration
  //     } else {
  //       setSlotLoading(false);
  //       setAppointmentSlots(slots); // If we didn't cover the full duration, return slots as they are
  //     }
  //   }
  // };
 


  const DateFormatter = (dateparameter) => {
    const date = new Date(dateparameter);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      console.error("Invalid date parameter:", dateparameter);
      return "Invalid date"; 
    }
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "UTC", // Force UTC time formatting
    };

    // Format the date to UTC
    const formattedDate = new Intl.DateTimeFormat("en-US", options).format(
      date
    );
    return formattedDate;
  };


  
 


  return (
    <div className="col-lg-12 ">
      {/* {props.showAlert && (
        <Alert
          message="Success"
          description={resultComfirm}
          type="success"
          showIcon
          closable 
          style={{
    position: 'fixed', // Fix the position at the top of the screen
    top: '10px', // Distance from the top of the page
    left: '50%', // Center it horizontally
    transform: 'translateX(-50%)', // Offset to center perfectly
    zIndex: 9999, // Make sure it appears above other content
  }} 
          onClose={() => {
            props.setshowAlert(false)
            setresultComfirm("")
            }} // Close the alert when the close button is clicked
        />
      )} */}
      <div
        className="card shadow-lg rounded"
        style={{ marginTop: 15, marginBottom: 10 }}
      >
        <div className={props.styleName}>
          <View
            style={{ flexDirection: "row", justifyContent: "space-between" }}
          >
            <Text style={{ fontWeight: "500", color: "#fff" }}>
              {props.appointmentDate}
            </Text>
            {/* <Text style={{ fontWeight: '500', color: '#fff' }}>{props.firstitem}</Text> */}
          </View>
        </div>
        <div className="card-body">
          {/* <h4 className="card-title"><i className="mdi mdi-18px mdi-home-map-marker" /> {props.praticeAddress}</h4> */}
          <h4 className="card-title">
            <i className="mdi mdi-18px mdi-home-map-marker" /> {props.firstitem}
          </h4>
          <p className="card-text">
            <i
              style={{ marginRight: 4 }}
              className="mdi mdi-18px mdi-calendar-clock"
            />
            {props.secondItem}
          </p>

          <p className="card-text">
            <i className="mdi mdi-18px mdi-hospital-marker" />
            {props.location}
          </p>

          {props.reason !== undefined && (
            <div>
              <View
                style={{
                  width: "100%",
                  marginTop: 0,
                  borderTopWidth: 1,
                  borderTopColor: "#DDDDDD",
                }}
              ></View>
              <p className="card-text">
                <i style={{ marginRight: 4 }} className={props.icTpye} />
                {props.reason}
              </p>
              {props.reasonForCancel !== null && (
                <p className="card-text">
                  <i
                    style={{ marginRight: 4 }}
                    className={props.icTpyeCancel}
                  />
                  {props.reasonForCancel}
                </p>
              )}
            </div>
          )}
          {props.IsAllowedReschedule && (
            <div className="d-flex justify-content-end">
              <Button
                disabled={props.IsAllowedReschedule ? false : true}
                loading={props.appointmentID === props.AppointmentID ? isAvailableDateForAppointmentData : false}
                key="submit"
                type="primary"
                onClick={() => {
                  props.setAppointmentID(props.appointmentID);
                  props.setprovidersechduleID(props.ProviderScheduleID);
                  props.setCurrentDate(new Date(props.appointmentDate));
                  props.setSelectedDuration(props.Duration)
                  props.setClinicName(props.firstitem)
                  // setAppointmentDate(new Date(props.appointmentDate));
                  const payload={
                    PatientID: Profile[0].resource.id ,
                    ProviderScheduleID: props.ProviderScheduleID ,
                    StartDate: DateFormatter(props.StartDate),
                    EndDate: DateFormatter(props.EndDate),
                    AppointmentID:props.appointmentID ,
                  }
                  dispatch(appServices.AvailableDateForAppointment(payload))
                  // dateForAppointment(
                  //   props.ProviderScheduleID,
                  //   props.appointmentID,
                  //   DateFormatter(props.StartDate),
                  //   DateFormatter(props.EndDate)
                  // );
                }}
              >
                Reschedule
              </Button>
            </div>
          )}
        </div>
        
       
      
      </div>
    </div>
  );
};

const styles = StyleSheet.create({
  listItems: {
    flex: 0.5,
    //    alignSelf:'baseline',
    //s  alignItems: 'space-between',
  },
  listRow: {
    flexDirection: "row",
    justifyContent: "flex-start",
    padding: 5,
    marginTop: 10,
    marginLeft: 5,
    marginBottom: 3,
    marginRight: 5,
    borderRadius: 10,
    borderWidth: 0,
    borderColor: "#D1D1D6",
    backgroundColor: "white",
  },
  doctorTilteFont: {
    color: "#212121",
    fontSize: 17,
  },
  patientFont: {
    marginTop: 3,
    fontSize: 16,
    color: "#455A64",
  },
  dateSectionMainStyle: {
    opacity: 1,
    position: "relative",
    backgroundColor: "transparent",
    width: 50,
    height: 75,
    marginTop: 10,
    marginBottom: 10,
    justifyContent: "center",
    alignItems: "center",
  },
  dateSectionBackground: {
    opacity: 1,
    backgroundColor: "#1c4490",
    borderRadius: 5,
    width: 55,
    height: 65,
  },
  dateSectionTextPlacement: {
    opacity: 1,
    position: "absolute",
    height: "100%",
    width: "100%",
    borderRadius: 10,
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  appointmentTypeStyle: {
    marginTop: 5,
    marginBottom: 5,
    marginRight: 35,
    flex: 1,
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },

  appointmentTypeBox: {
    backgroundColor: "#C5C5C5",
    borderRadius: 5,
    marginBottom: 5,
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  appointmentTypeStyleText: {
    textAlign: "center",
    width: 80,
    marginBottom: 5,
    color: "#00A500",
    fontWeight: "400",
    fontSize: 16,
  },
  toptextDate: {
    fontSize: 14,
    fontWeight: "400",
    color: "#fff",
  },
});

export default AppointmentHandler;
